module.exports = __webpack_public_path__ + "img/cooperationContentImg1.98ee070f.png";